import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';

import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'training-load-chart',
  templateUrl: './training-load-chart.component.html',
  styleUrls: ['./training-load-chart.component.scss'],
})
export class TrainingLoadChartComponent implements OnChanges, OnInit {
  @Input() lineSeries?: number[];
  @Input() barSeries?: number[];
  @Input() lineLabel?: string;
  @Input() barLabel?: string;
  @Input() seriesLabels: string[];
  @Input() height: string;
  @Input() thresholdValues?: number[];
  @Input() thresholdLabels?: string[];
  @Input() thresholdColors?: string[];
  @Input() xLabel = '';
  @Input() yLabel = '';

  @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;

  type: ChartType = 'bar';
  legend = true;
  plugins = [];
  chartData: ChartDataSets[] = [];
  options: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      labels: {
        usePointStyle: true,
      },
    },
    scales: {
      yAxes: [
        {
          id: 'y-axis',
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 8,
          },
          scaleLabel: {
            display: true,
            labelString: this.yLabel,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: this.xLabel,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';

          if (label) {
            label += ': ';
          }
          const yLabel = typeof tooltipItem.yLabel === 'string' ? parseFloat(tooltipItem.yLabel) : tooltipItem.yLabel;
          label += Math.round(yLabel * 100) / 100;
          return label;
        },
      },
    },
  };

  constructor() {}

  ngOnInit(): void {
    this.options.scales.xAxes[0].scaleLabel.labelString = this.xLabel;
    this.options.scales.yAxes[0].scaleLabel.labelString = this.yLabel;
  }

  ngOnChanges() {
    this.chartData = [];
    if (this.barSeries && this.barLabel) {
      this.chartData.push({ data: this.barSeries, label: this.barLabel, type: 'bar', pointStyle: 'rect' });
    }
    if (this.lineSeries && this.lineLabel) {
      this.chartData.push(
        { data: this.lineSeries, label: this.lineLabel, type: 'line', fill: false, pointStyle: 'circle', pointRadius: 4 }
      );
    }
    if (this.thresholdValues && this.thresholdLabels && this.thresholdColors) {
      const len = this.barSeries ? this.barSeries.length : this.lineSeries ? this.lineSeries.length : 0;
      for (let i = 0; i < this.thresholdValues.length; i++) {
        this.chartData.push({
          data: new Array(len).fill(this.thresholdValues[i]),
          label: this.thresholdLabels[i],
          type: 'line',
          borderWidth: 1.5,
          fill: false,
          borderColor: this.thresholdColors[i],
          pointStyle: 'dash',
          borderDash: [10, 5],
        });
      }
    }
  }
}
